// extracted by mini-css-extract-plugin
export default {"upload_cartoon":"UploadCartoonButton_upload_cartoon__N4lsg"};